import { Component, Input } from '@angular/core';
import { CommonModule, NgComponentOutlet } from '@angular/common';

import { Components } from '../../cockpitComponents';
import { GridComponent } from '../../cockpitDesigner/cockpitDesigner.models';

@Component({
  selector: 'app-cockpit-component-renderer',
  standalone: true,
  imports: [NgComponentOutlet, CommonModule],
  templateUrl: './app-cockpit-component-renderer.html',
  styleUrl: './component-renderer.component.css'
})
export class CockpitComponentRenderer {

  @Input() componentsList: GridComponent[] = [];

  @Input() cellId!: string;
  @Input() rowId!: string;
  @Input() columnIndex!: number;
  @Input() columnId!: string;

  components = Components;
}